import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss']
})
export class TeamComponent implements OnInit {
teamData:any;
  constructor() { }

  ngOnInit(): void {
    this.teamData =teamList;
  }

}
export const teamList = [
  {name:'Omer Khan', designation:'CEo- Co-founder', imagSrc:'team.png'},
  {name:'Omer Khan', designation:'CEo- Co-founder', imagSrc:'team.png'},
  {name:'Omer Khan', designation:'CEo- Co-founder', imagSrc:'team.png'},
  {name:'Omer Khan', designation:'CEo- Co-founder', imagSrc:'team.png'},
  {name:'Omer Khan', designation:'CEo- Co-founder', imagSrc:'team.png'},
  {name:'Omer Khan', designation:'CEo- Co-founder', imagSrc:'team.png'},
]